import { Component, ElementRef, input, model, viewChild, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'

import { MatTooltipModule } from '@angular/material/tooltip'
@Component({
  selector: 'lib-nav-text-search',
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './nav-text-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './nav-text-search.component.scss',
})
export class NavTextSearchComponent {
  readonly input = viewChild.required<ElementRef<HTMLInputElement>>('input')

  readonly label = input<string>('Suche')
  readonly text = model<string>()

  readonly showShortcut = input(false)
}
